const steps = [
    {id: 1, title: 'Moneris Checkout Overview', name: 'overview'},
    {id: 2, title: 'Client-Side Checkout Page', name: 'client_side'},
    {id: 3, title: 'Preload Request', name: 'preload_req'},
    {id: 4, title: 'Displaying in the Browser', name: 'disp_browser'},
    {id: 5, title: 'Receipt Request', name: 'receipt_req'},
    {id: 6, title: 'Terminating Instance', name: 'terminating'},
    {id: 7, title: 'Handling Callbacks', name: 'callbacks'},
    {id: 8, title: 'Testing MCO Integration', name: 'testing'},
    {id: 9, title: 'Production With MCO', name: 'production'}
]

export default steps